export const SET_PICTURE_GALLERIES = 'picture_galleries/SET_PICTURE_GALLERIES'
export const SET_LOADING = 'picture_galleries/SET_LOADING'
export const SET_COVER_PICTURE = 'picture_galleries/SET_COVER_PICTURE'
